import * as React from "react";
import { Image, tokens, makeStyles } from "@fluentui/react-components";

/**
 * Interface définissant les propriétés du composant Header.
 */
export interface HeaderProps {
  title: string; // Titre affiché dans l'en-tête
  logo: string; // URL ou chemin de l'image du logo
  message: string; // Message affiché sous le logo
}

/**
 * Composant Header : affiche un en-tête avec un logo, un titre et un message.
 * @param {HeaderProps} props - Propriétés du composant.
 * @returns {JSX.Element} - Le composant React.
 */
const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { title, logo, message } = props;
  const styles = useStyles();

  return (
    <section className={styles.welcome__header}>
      {/* Affiche le logo */}
      <Image width="90" height="90" src={logo} alt={title} />
    </section>
  );
};

export default Header;

const useStyles = makeStyles({
  welcome__header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: "12px",
    paddingTop: "12px",
    backgroundColor: tokens.colorNeutralBackground3,
  },
  message: {
    fontSize: tokens.fontSizeHero900,
    fontWeight: tokens.fontWeightRegular,
    fontColor: tokens.colorNeutralBackgroundStatic,
  },
});
